import consumer from "./consumer";

let assistantChannel = null;

function connectToAssistantChannel(thread_id, callback_fn, reconnected_fn) {
  if (assistantChannel) return;

  let hasConnectedBefore = false;

  assistantChannel = consumer.subscriptions.create(
    { channel: "AssistantChannel", thread_id: thread_id.toString()},
    {
      connected() {
        console.log(`Connected`);
        // Broadcasts sent while the socket was down are lost — let the page
        // resync its state after every reconnect.
        if (hasConnectedBefore && typeof reconnected_fn === 'function') {
          reconnected_fn();
        }
        hasConnectedBefore = true;
      },

      disconnected() {
        console.log("Disconnected");
      },

      received(data) {
        console.log("Received:", data);
        if (typeof callback_fn === 'function') {
          callback_fn(data);
        }
      },

      speak(message) {
        this.perform("speak", { message: message, thread_id: thread_id });
      }
    }
  );

  window.assistantChannel = assistantChannel; 
}

function disconnectFromAssistantChannel() {
  if (assistantChannel) {
    consumer.subscriptions.remove(assistantChannel);
    assistantChannel = null;
    window.assistantChannel = assistantChannel
  }
}

window.connectToAssistantChannel = connectToAssistantChannel;
window.disconnectFromAssistantChannel = disconnectFromAssistantChannel;




